module.exports = __webpack_public_path__ + "static/media/LI9.49cf2464.jpg";